module.exports = __webpack_public_path__ + "static/media/undraw_revenue_3osh.9f79af53.png";